import React from 'react'
import { PlusCircle } from '@phosphor-icons/react'
import resolveIcon, { isPhosphorIconSource } from '../icon/resolveIcon'

// TODO: Cuando termine la migración de GoogleIcon a Phosphor, quitar el
// fallback de string / filled y dejar solo componente Phosphor.
function PrimaryActionButton({
  text,
  onClick,
  type = 'button',
  icon: Icon = PlusCircle,
  iconNode = null,
  iconSize = 22,
  iconWeight = null,
  filled = false,
  disabled = false,
  className = ''
}) {
  const usePhosphorClass = isPhosphorIconSource({ icon: Icon, iconNode })
  const rootClass = [
    'create-action-btn',
    usePhosphorClass ? 'create-action-btn--phosphor' : '',
    className
  ]
    .filter(Boolean)
    .join(' ')
  const iconElement = resolveIcon({
    icon: Icon,
    iconNode,
    size: iconSize,
    weight: iconWeight,
    filled
  })

  return (
    <button type={type} className={rootClass} onClick={onClick} disabled={disabled}>
      <span className="create-action-btn__icon" aria-hidden="true">
        {iconElement || '+'}
      </span>
      <span className="create-action-btn__text">{text}</span>
    </button>
  )
}

export { PrimaryActionButton }

export default PrimaryActionButton
